// Copyright 2021 Amazon.com, Inc. or its affiliates. All Rights Reserved.
import React from "react";
import { createRoot } from "react-dom/client";
import "./styles/App.css";
import "./styles/CustomBranding.css";
import { App } from "./components/App";
import { App as StepFlowApp } from "./stepFlowComponents/App/App";
import "./utils/i18nUtils";
import { getLogger } from "@utils/ermineLoggerUtils";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { isFeatureEnabled } from "@utils/configurationUtils";
import { v4 as uuidv4 } from "uuid";

// Enable hot module replacement in development
if (module.hot) {
    module.hot.accept();
}

if (!window.visitId) {
    // Unique ID generated per page visit. A new ID is generated on each page load/refresh.
    window.visitId = uuidv4();
}

// Initialize logger
getLogger();

const container = document.getElementById("root");
if (!container) {
    throw new Error("Failed to find the root element");
}
const root = createRoot(container);

if (isFeatureEnabled("stepNavigationFlow")) {
    root.render(<StepFlowApp />);
} else {
    const queryClient = new QueryClient({
        defaultOptions: {
            queries: {
                networkMode: "always",
                refetchOnWindowFocus: false,
            },
            mutations: {
                networkMode: "always",
            },
        },
    });

    root.render(
        <React.StrictMode>
            <QueryClientProvider client={queryClient}>
                <App />
            </QueryClientProvider>
        </React.StrictMode>
    );
}
